<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
			:minWidth="800"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-start">
							<v-icon color="white" small class="info-icon mt-1 mr-2">mdi-account-plus-outline</v-icon>
							<div>
								<p class="mb-0 font-weight-bold text-primary title" v-if="$store.state.users.editPermissionsUser">Editar Permisos</p>
								<p class="mb-0 caption"><b>{{$store.state.users.editPermissionsUser.profile.name}} {{$store.state.users.editPermissionsUser.profile.lastname}}</b> <span v-if="$store.state.companies.selectedCompany">- Empresa: {{$store.state.companies.selectedCompany.company.name}}</span></p>
							</div>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
				<v-card-text class="pa-0">
					<div class="py-4 px-8">
						<v-form ref="form" v-model="validform" class="mt-0">
              <v-row class="mb-4">
                <v-col cols="12">
									<v-btn-toggle
										v-model="selectedCategory"
										dense
										color="green"
										class="d-flex flex-row pb-3"
										style="overflow-x: scroll;"
									>
										<v-btn :value="1" class="flex-grow-1">
											<p class="mb-0 caption font-weight-bold">Usuarios</p>
										</v-btn>
										<v-btn :value="2" class="flex-grow-1">
											<p class="mb-0 caption font-weight-bold">Empresas</p>
										</v-btn>
										<v-btn :value="3" class="flex-grow-1">
											<p class="mb-0 caption font-weight-bold">CRM/Solicitudes</p>
										</v-btn>
										<v-btn :value="4" class="flex-grow-1">
											<p class="mb-0 caption font-weight-bold">Agenda</p>
										</v-btn>
										<v-btn :value="5" class="flex-grow-1">
											<p class="mb-0 caption font-weight-bold">Clientes</p>
										</v-btn>
										<v-btn :value="6" class="flex-grow-1">
											<p class="mb-0 caption font-weight-bold">Gestión Antecedentes</p>
										</v-btn>
										<v-btn :value="7" class="flex-grow-1">
											<p class="mb-0 caption font-weight-bold">Contratos / Presupuestos</p>
										</v-btn>
									</v-btn-toggle>
								</v-col>
								<v-col cols="12" sm="12" class="py-0">
									<div class="permisos-type-container" v-if="selectedCategory == 1">
										<h2 class="mb-0 subtitle-1 font-weight-bold light-text">Usuarios</h2>
										<v-checkbox v-model="selectAllUsers" color="black" label="Seleccionar todo" hide-details dense></v-checkbox>
										<v-row>
											<v-col cols="12">
												<v-checkbox v-model="permisos.view_users" color="black" label="Ver Usuarios" hide-details dense @change="changeViewUsers"></v-checkbox>
												<v-checkbox v-model="permisos.create_users" :disabled="!permisos.view_users" color="black" label="Crear Usuarios" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.edit_users" :disabled="!permisos.view_users" color="black" label="Editar Usuarios" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.delete_users" :disabled="!permisos.view_users" color="black" label="Eliminar Usuarios" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.edit_user_permissions" :disabled="!permisos.view_users" color="black" label="Editar Permisos Usuarios" hide-details dense></v-checkbox>
											</v-col>
										</v-row>
									</div>
									<div class="permisos-type-container " v-if="selectedCategory == 2">
										<h2 class="mb-0 subtitle-1 font-weight-bold light-text">Empresas</h2>
										<v-checkbox v-model="selectAllCompanies" color="black" label="Seleccionar todo" hide-details dense></v-checkbox>
										<v-row>
											<v-col cols="6">
												<v-checkbox v-model="permisos.edit_company" color="black" label="Editar Empresa" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.delete_company" color="black" label="Eliminar Empresa" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.view_company_roles" color="black" label="Ver Roles Empresa" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.create_company_roles" color="black" label="Crear Roles Empresa" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.edit_company_roles" color="black" label="Editar Roles Empresa" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.delete_company_roles" color="black" label="Eliminar Roles Empresa" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.company_request_validation" color="black" label="Validar Solicitudes Empresa" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.assign_responsible_user" color="black" label="Asignar Responsable" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.view_company_project_types" color="black" label="Ver Tipos de Proyectos" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.create_company_project_types" color="black" label="Crear Tipos de Proyectos" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.edit_company_project_types" color="black" label="Editar Tipos de Proyectos" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.delete_company_project_types" color="black" label="Eliminar Tipos de Proyectos" hide-details dense></v-checkbox>
											</v-col>
											<v-col cols="6">
												<v-checkbox v-model="permisos.company_project_planning" color="black" label="Planificación de Proyectos" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.create_company_project_specialties" color="black" label="Crear Proyectos / Especialidades" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.delete_company_project_specialties" color="black" label="Eliminar Proyectos / Especialidades" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.create_company_materials" color="black" label="Crear Tipo de Estructura" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.edit_company_materials" color="black" label="Editar Tipo de Estructura" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.delete_company_materials" color="black" label="Eliminar Tipo de Estructura" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.create_company_supervision_percents" color="black" label="Crear Porcentaje de Supervisión" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.edit_company_supervision_percents" color="black" label="Editar Porcentaje de Supervisión" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.delete_company_supervision_percents" color="black" label="Eliminar Porcentaje de Supervisión" hide-details dense></v-checkbox>
											</v-col>
										</v-row>
									</div>
								<!-- </v-col>
								<v-col cols="12" sm="6" class="py-0"> -->
									<div class="permisos-type-container" v-if="selectedCategory == 3">
										<h2 class="mb-0 subtitle-1 font-weight-bold light-text">CRM/Solicitudes</h2>
										<v-checkbox v-model="selectAllCrm" color="black" label="Seleccionar todo" hide-details dense></v-checkbox>
										<v-row>
											<v-col cols="6">
												<v-checkbox v-model="permisos.view_crm" color="black" label="Ver CRM/Solicitudes" hide-details dense @change="changeViewCrm"></v-checkbox>
												<v-checkbox v-model="permisos.delete_crm" :disabled="!permisos.view_crm" color="black" label="Eliminar Registro CRM/Solicitudes" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.edit_crm" :disabled="!permisos.view_crm" color="black" label="Editar Datos en Detalle CRM/Solicitudes" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.view_company_concepts" color="black" label="Visualizar Conceptos CRM/Solicitudes" hide-details dense @change="changeViewConcepts"></v-checkbox>
												<v-checkbox v-model="permisos.create_company_concepts" :disabled="!permisos.view_company_concepts" color="black" label="Crear Conceptos CRM/Solicitudes" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.edit_company_concepts" :disabled="!permisos.view_company_concepts" color="black" label="Editar Conceptos CRM/Solicitudes" hide-details dense></v-checkbox>
											</v-col>
											<v-col cols="6">
												<v-checkbox v-model="permisos.delete_company_concepts" :disabled="!permisos.view_company_concepts" color="black" label="Eliminar Conceptos CRM/Solicitudes" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.view_vt_maps" color="black" label="Ver Mapas de Visitas Técnicas" hide-details dense @change="changeViewVtMaps"></v-checkbox>
												<v-checkbox v-model="permisos.edit_vt_maps" :disabled="!permisos.view_vt_maps" color="black" label="Editar Polígonos de Visitas Técnicas" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.delete_vt_maps" :disabled="!permisos.view_vt_maps" color="black" label="Eliminar Polígonos de Visitas Técnicas" hide-details dense></v-checkbox>
											</v-col>
										</v-row>
									</div>
									<div class="permisos-type-container " v-if="selectedCategory == 4">
										<h2 class="mb-0 subtitle-1 font-weight-bold light-text">Agenda</h2>
										<v-checkbox v-model="selectAllSchedule" color="black" label="Seleccionar todo" hide-details dense></v-checkbox>
										<v-row>
											<v-col cols="12">
												<v-checkbox v-model="permisos.schedule_access" color="black" label="Acceso a Agenda" hide-details dense @change="changeViewSchedule"></v-checkbox>
												<v-checkbox v-model="permisos.schedule_assignment" :disabled="!permisos.schedule_access" color="black" label="Asignación a otros usuarios" hide-details dense></v-checkbox>
											</v-col>
										</v-row>
									</div>
									<div class="permisos-type-container " v-if="selectedCategory == 5">
										<h2 class="mb-0 subtitle-1 font-weight-bold light-text">Clientes</h2>
										<v-checkbox v-model="selectAllClients" color="black" label="Seleccionar todo" hide-details dense></v-checkbox>
										<v-row>
											<v-col cols="6">
												<v-checkbox v-model="permisos.view_clients" color="black" label="Acceso a Clientes" hide-details dense @change="changeViewClients"></v-checkbox>
												<v-checkbox v-model="permisos.prospect_chat" :disabled="!permisos.view_clients" color="black" label="Chat Prospectos" hide-details dense></v-checkbox>
											</v-col>
										</v-row>
									</div>
									<div class="permisos-type-container " v-if="selectedCategory == 6">
										<h2 class="mb-0 subtitle-1 font-weight-bold light-text">Gestión Antecedentes</h2>
										<v-checkbox v-model="selectAllPreprojects" color="black" label="Seleccionar todo" hide-details dense></v-checkbox>
										<v-row>
											<v-col cols="6">
												<v-checkbox v-model="permisos.view_preprojects" color="black" label="Acceso a Gestión Antecedentes" hide-details dense @change="changeViewPreprojects"></v-checkbox>
												<v-checkbox v-model="permisos.edit_preprojects" :disabled="!permisos.view_preprojects" color="black" label="Editar Gestión Antecedentes" hide-details dense></v-checkbox>
											</v-col>
										</v-row>
									</div>
									<div class="permisos-type-container " v-if="selectedCategory == 7">
										<h2 class="mb-0 subtitle-1 font-weight-bold light-text">Contratos / Presupuestos</h2>
										<v-checkbox v-model="selectAllContractsBudgets" color="black" label="Seleccionar todo" hide-details dense></v-checkbox>
										<v-row>
											<v-col cols="6">
												<v-checkbox v-model="permisos.view_project_serials_table" color="black" label="Acceso a Tabla Correlativos" hide-details dense @change="changeViewBudgets"></v-checkbox>
												<v-checkbox v-model="permisos.view_reports" color="black" label="Acceso a Informes" hide-details dense @change="changeViewBudgets"></v-checkbox>
												<v-checkbox v-model="permisos.view_budgets" color="black" label="Acceso a Presupuestos" hide-details dense @change="changeViewBudgets"></v-checkbox>
												<v-checkbox v-model="permisos.view_contracts" color="black" label="Acceso a Contratos" hide-details dense @change="changeViewContracts"></v-checkbox>
												<v-checkbox v-model="permisos.edit_contracts" :disabled="!permisos.view_contracts" color="black" label="Editar Contratos" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.annulation_subcontracts" :disabled="!permisos.view_contracts" color="black" label="Suspender Subcontratos" hide-details dense></v-checkbox>
												<v-checkbox v-model="permisos.restore_subcontracts" :disabled="!permisos.view_contracts" color="black" label="Restaurar Subcontratos" hide-details dense></v-checkbox>
											</v-col>
										</v-row>
									</div>
								</v-col>
							</v-row>
							<v-row align="center">
								<v-col cols="12">
									<div class="d-flex flex-row justify-end">
										<v-btn
											class="mx-2 my-1"
											color="white"
											raised
											@click="closeModal"
										>
											<p class="mb-0 text-primary">Cancelar</p>
										</v-btn>
										<v-btn
											class="mx-2 my-1"
											color="#524D4D"
											raised
											dark
											:loading="loadingData"
											@click="updatePermissions"
										>
											<p class="mb-0">Confirmar</p>
										</v-btn>
									</div>
								</v-col>
							</v-row>
						</v-form>
					</div>
				</v-card-text>
			</v-card>
		</modal>
	</div>
</template>

<script>
import {updateUserCompanyPermissions} from '@/helpers/api/company'
export default {
	name: 'EditPermisosUserModal',
	computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		userInfo() {
			return this.$store.state.user.userInfo
		},
    selectAllUsers: {
      get() {
        return this.permisos.view_users && this.permisos.create_users && this.permisos.edit_users && this.permisos.delete_users && this.permisos.edit_user_permissions;
      },
      set(value) {
				this.permisos = {
					...this.permisos,
					view_users: value,
					create_users: value,
					edit_users: value,
					delete_users: value,
					edit_user_permissions: value
				}
      }
    },
    selectAllCompanies: {
      get() {
        return this.permisos.edit_company && this.permisos.delete_company && this.permisos.view_company_roles && this.permisos.create_company_roles && this.permisos.edit_company_roles && this.permisos.delete_company_roles && this.permisos.company_request_validation && this.permisos.assign_responsible_user && this.permisos.view_company_project_types && this.permisos.create_company_project_types && this.permisos.edit_company_project_types && this.permisos.delete_company_project_types && this.permisos.company_project_planning && this.permisos.create_company_project_specialties && this.permisos.delete_company_project_specialties && this.permisos.create_company_materials && this.permisos.edit_company_materials && this.permisos.delete_company_materials && this.permisos.create_company_supervision_percents && this.permisos.edit_company_supervision_percents && this.permisos.delete_company_supervision_percents;
      },
      set(value) {
				this.permisos = {
					...this.permisos,
					edit_company: value,
					delete_company: value,
					view_company_roles: value,
					create_company_roles: value,
					edit_company_roles: value,
					delete_company_roles: value,
					company_request_validation: value,
					assign_responsible_user: value,
					view_company_project_types: value,
					create_company_project_types: value,
					edit_company_project_types: value,
					delete_company_project_types: value,
					company_project_planning: value,
					create_company_project_specialties: value,
					delete_company_project_specialties: value,
					create_company_materials: value,
					edit_company_materials: value,
					delete_company_materials: value,
					create_company_supervision_percents: value,
					edit_company_supervision_percents: value,
					delete_company_supervision_percents: value,
				}
      }
    },
    selectAllCrm: {
      get() {
        return this.permisos.view_crm && this.permisos.delete_crm && this.permisos.edit_crm && this.permisos.view_company_concepts && this.permisos.create_company_concepts && this.permisos.edit_company_concepts && this.permisos.delete_company_concepts && this.permisos.view_vt_maps && this.permisos.edit_vt_maps && this.permisos.delete_vt_maps;
      },
      set(value) {
				this.permisos = {
					...this.permisos,
					view_crm: value,
					delete_crm: value,
					edit_crm: value,
					view_company_concepts: value,
					create_company_concepts: value,
					edit_company_concepts: value,
					delete_company_concepts: value,
					view_vt_maps: value,
					edit_vt_maps: value,
					delete_vt_maps: value,
				}
      }
    },
    selectAllSchedule: {
      get() {
        return this.permisos.schedule_access && this.permisos.schedule_assignment;
      },
      set(value) {
				this.permisos = {
					...this.permisos,
					schedule_access: value,
					schedule_assignment: value
				}
      }
    },
    selectAllClients: {
      get() {
        return this.permisos.view_clients && this.permisos.prospect_chat;
      },
      set(value) {
				this.permisos = {
					...this.permisos,
					view_clients: value,
					prospect_chat: value
				}
      }
    },
    selectAllPreprojects: {
      get() {
        return this.permisos.view_preprojects && this.permisos.edit_preprojects;
      },
      set(value) {
				this.permisos = {
					...this.permisos,
					view_preprojects: value,
					edit_preprojects: value
				}
      }
    },
    selectAllContractsBudgets: {
      get() {
        return this.permisos.view_contracts && this.permisos.edit_contracts && this.permisos.view_budgets;
      },
      set(value) {
				this.permisos = {
					...this.permisos,
					view_project_serials_table: value,
					view_reports: value,
					view_budgets: value,
					view_contracts: value,
					edit_contracts: value,
					annulation_subcontracts: value,
					restore_subcontracts: value,
				}
      }
    }
	},
	data: () => ({
		indexModal: + new Date(),
		permisos: {
		},
		selectedCategory: 1,
		loadingData: false,
		validform: false
	}),
	mounted(){
		if(this.$store.state.users.editPermissionsUser && this.$store.state.users.editPermissionsUser.company_rol){
			this.permisos = this.$store.state.users.editPermissionsUser.company_rol.capabilities ?? {}
		}
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
	},
	methods: {
		changeViewUsers(){
			if(!this.permisos.view_users){
				this.permisos = {
					...this.permisos,
					create_users: false,
					edit_users: false,
					delete_users: false,
					edit_user_permissions: false,
				}
			}
		},
		changeViewCrm(){
			if(!this.permisos.view_crm){
				this.permisos = {
					...this.permisos,
					delete_crm: false,
					edit_crm: false,
				}
			}
		},
		changeViewConcepts(){
			if(!this.permisos.view_company_concepts){
				this.permisos = {
					...this.permisos,
					create_company_concepts: false,
					edit_company_concepts: false,
					delete_company_concepts: false,
				}
			}
		},
		changeViewVtMaps(){
			if(!this.permisos.view_vt_maps){
				this.permisos = {
					...this.permisos,
					edit_vt_maps: false,
					delete_vt_maps: false
				}
			}
		},
		changeViewSchedule(){
			if(!this.permisos.schedule_access){
				this.permisos = {
					...this.permisos,
					schedule_assignment: false
				}
			}
		},
		changeViewClients(){
			if(!this.permisos.view_clients){
				this.permisos = {
					...this.permisos,
					prospect_chat: false
				}
			}
		},
		changeViewPreprojects(){
			if(!this.permisos.view_preprojects){
				this.permisos = {
					...this.permisos,
					edit_preprojects: false
				}
			}
		},
		changeViewContracts(){
			if(!this.permisos.view_contracts){
				this.permisos = {
					...this.permisos,
					edit_contracts: false,
					annulation_subcontracts: false,
					restore_subcontracts: false,
				}
			}
		},
		changeViewBudgets(){
			// if(!this.permisos.view_budgets){
			// }
		},
		async updatePermissions(){
			this.loadingData = true
			const user_id = this.$store.state.users.editPermissionsUser.id
			const data = {
				user_id,
				'capabilities': {...this.permisos}
			}
			const permission = await updateUserCompanyPermissions(data)
			this.loadingData = false
			if(permission.code == 200){
				if(this.userInfo.id == user_id){
					this.$store.dispatch('user/getUserInfo')
				}
				this.$store.dispatch('users/getUserFromCompany', {start: 0, limit: 30})
				const data = {
					message: 'Permisos actualizados correctamente',
					title: 'Ok',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3'
				}
				this.$store.dispatch('general/addMessage', data)
				this.closeModal()
			}
			else{
				const data = {
					message: 'Por favor intenta nuevamente.',
					title: 'Error',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', data)
			}
		},
		closeModal(){
			this.$store.commit('users/setEditPermissionsUser', null)
			this.$store.commit('users/setEditPermisosUserModal', false)
			this.permisos = {}
			this.validform = true
			this.loadingData = false
		}
	}
};
</script>

<style scoped>
	.info-container{
		color: #606060;
	}
	.text-primary{
		color: #524D4D;
	}
	.info-icon{
		background-color: #524D4D;
		border-radius: 25px;
		padding: 3px;
		width: 35px;
		height: 35px;
	}
	.info-icon.small-icon{
		width: 25px;
		height: 25px;
	}
	.info-img{
		width: 100%;
		max-height: 50px;
		object-fit: contain;
	}
	.adjuntos-container{
		background-color: #EFEFEF;
		max-height: 95px;
		overflow-y: scroll;
	}
	.interaction-container{
		width: 100%;
		background-color: #E5E9F2;
		border-radius: 5px;
		position: relative;
		padding: 12px;
	}
	.user-avatar.small{
		width: 25px;
		height: 25px;
	}
	.light-text{color: #959595;}
	.permisos-type-container{
		border: 1px solid #959595;
		border-radius: 10px;
		padding: 10px;
	}
	/deep/ .permisos-type-container .v-input--checkbox label.v-label{font-size: 14px;}
	/deep/ .permisos-type-container .theme--light.v-input,
	/deep/ .permisos-type-container .theme--light.v-label{
		color: rgba(0, 0, 0, 1);
	}
	/deep/ .permisos-type-container .theme--light.v-input--is-disabled,
	/deep/ .permisos-type-container .theme--light.v-label--is-disabled{color: rgba(0, 0, 0, 0.3)}
</style>